"use client";
import { UsersDetailsSkeletons } from "../../components/skeletons/users-skeletons";
import { useUserDetail } from "../../../hooks/api/user-table/hooks";
import { Breadcrumb, Button } from "antd";
import { ArrowLeft } from "lucide-react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useAccountantDetail } from "../../../hooks/api/accountant/hooks";

const AccountDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: detail, isLoading } = useAccountantDetail(id ?? "");

  return (
    <div className="w-full">
      {/* TOP HEADER */}
      <div className="mb-6">
        <div className="flex justify-start w-full">
          <Button
            className="flex text-who items-center gap-2 mb-2 cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={20} className="text-primary" />
            <span className="text-primary font-semibold">Back</span>
          </Button>
        </div>

        <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">
          Accountant Details
        </h1>

        <Breadcrumb
          separator=">"
          items={[
            { title: "Dashboard" },
            { title: "Accountant" },
            { title: "Accountant Detail" },
          ]}
          className="text-xs sm:text-base"
        />


        <div className="flex justify-end w-full">
          <Button  className="bg-primary px-10" onClick={() => navigate(`/accountant/edit/${id}`)} >
            Edit
          </Button>
        </div>
      </div>

      {/* GRID LAYOUT */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* LEFT */}
        <div className="space-y-6">
          {/* BASIC INFO */}
          {isLoading ? (
            <UsersDetailsSkeletons />
          ) : (
            <SectionCard title="Basic Info">
              <TwoCol label="User ID" value={detail?.data?._id ?? ""} />

              <TwoCol label="Full Name" value={detail?.data?.name ?? ""} />
              <TwoCol
                label="Designation"
                value={detail?.data?.designation ?? ""}
              />
              <TwoCol label="Email" value={detail?.data?.email ?? "N/A"} />
              <TwoCol label="Phone" value={detail?.data?.phone ?? ""} />
              <TwoCol
                label="Experience"
                value={detail?.data?.experience ?? ""}
              />
              <TwoCol
                label="Account Status"
                value={detail?.data?.status ? "Active" : "Inactive"}
              />

              <TwoCol label="Total No. Of Consultations" value="0" />
              <TwoCol label="Today Consultations" value="0" />
            </SectionCard>
          )}
        </div>

        {/* RIGHT */}
        <div className="space-y-6 col-span-1 lg:col-span-1">
          {/* FILING SUMMARY */}
          {isLoading ? (
            <UsersDetailsSkeletons />
          ) : (
            <SectionCard title="Filing Summary">
              <TwoCol label="Current Filing" value="Self Assessment 2024-25" />
              <TwoCol label="Progress" value="72% Complete" />
              <TwoCol label="Last Updated" value="2 hours ago" />
              <TwoCol label="Status" value="In progress" />
            </SectionCard>
          )}
        </div>
      </div>
    </div>
  );
};

// ---------------------
// COMPONENTS
// ---------------------

const SectionCard = ({
  title,
  link,
  children,
}: {
  title: string;
  link?: string;
  children: any;
}) => (
  <div className="p-5 rounded-xl bg-[#FFEFE5] border border-[#F8D2BF]">
    <div className="flex justify-between mb-3 border-b-primary border-b pb-1 w-full">
      <h3 className="font-semibold text-lg text-primary ">{title}</h3>
      {link && <span className="text-primary cursor-pointer">{link}</span>}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{children}</div>
  </div>
);

const TwoCol = ({ label, value }: { label: string; value: string }) => (
  <div>
    <p className="text-xs text-primary">{label}</p>
    <p className="text-sm font-medium text-gray-800">{value}</p>
  </div>
);

const DocumentItem = ({ name }: { name: string }) => (
  <div className="flex items-center gap-3 bg-white border px-3 py-2 rounded-lg shadow-sm">
    <span className="text-red-600">📄</span>
    <span className="text-sm text-gray-800">{name}</span>
  </div>
);

export default AccountDetails;
